const handleSessionIdQueryParam = function () {
  if (window.location.href.indexOf('?grandidsession=') !== -1) { // is grandidsession param present
    const urlParams = new URLSearchParams(window.location.search) // get the params
    localStorage.setItem('sessionId', urlParams.get('grandidsession')) // set the value of the param to localStorage
    window.location.href = window.location.origin + window.location.pathname // and then clear it from URL
  }
}

export {
  handleSessionIdQueryParam
}



// WEBPACK FOOTER //
// ./src/plugins/queryparam.js